import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from '@/modules/channels/routers'

export default {
    install: () => {
        RouteRegister.handle(routers)
    }
}